
import React, { useContext } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";

const MENU = [
  {
    label: "Enquiries",
    route: "/trading/enquiries",
    perms: ["TRADING_ENQUIRY_VIEW", "TRADING_ENQUIRY_CREATE"],
    perms: ["WMS_DASHBOARD"],
    icon: "fas fa-envelope",
  },
  {
    label: "Trading Costing",
    route: "/trading/costings",
    perms: ["TRADING_COSTING_VIEW"],
    perms: ["WMS_DASHBOARD"],
    icon: "fas fa-calculator",
  },
  {
    label: "Trading Quotations",
    route: "/trading/quotations",
    perms: ["TRADING_QUOTATION_VIEW"],
    perms: ["WMS_DASHBOARD"],
    icon: "fas fa-file-invoice-dollar",
  },
  {
    label: "Trading Sales Orders",
    route: "/trading/sales-orders",
    perms: ["TRADING_SALES_ORDER_VIEW"],
    perms: ["WMS_DASHBOARD"],
    icon: "fas fa-shopping-cart",
    },

    {
      label: "Trading Dispatch Orders",
      route: "/trading/dispatch-orders",
      perms: ["TRADING_DISPATCH_ORDER_VIEW"],
      perms: ["WMS_DASHBOARD"],
      icon: "fas fa-truck",
    },
    {
    label: "Trading Actual Dispatch",
    route: "/trading/actual-dispatches",
    perms: ["TRADING_ACTUAL_DISPATCH_VIEW"],
    perms: ["WMS_DASHBOARD"],
    icon: "fas fa-shipping-fast",
  },
  {
  label: "Trading Sales Invoices",
  route: "/trading/sales-invoices",
  perms: ["TRADING_SALES_INVOICE_VIEW"],
  perms: ["WMS_DASHBOARD"],
  icon: "fas fa-file-invoice",
},
];

export default function TradingSidebar({ expanded, onToggle }) {
  const { permissions } = useContext(AuthContext);
  const location = useLocation();

  const canView = (keys) =>
    keys.some((key) => permissions?.[key]?.view === true);

  return (
    <aside
      style={{
        width: expanded ? "260px" : "64px",
        transition: "width 0.22s ease",
        background: "#1f2937",
        color: "#fff",
        minHeight: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 100,
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          height: 56,
          display: "flex",
          alignItems: "center",
          justifyContent: expanded ? "space-between" : "center",
          padding: expanded ? "0 12px" : 0,
          borderBottom: "1px solid #374151",
        }}
      >
        {expanded && <strong>TRADING</strong>}

        <button
          type="button"
          aria-label="Toggle Trading sidebar"
          onClick={() => onToggle(!expanded)}
          style={{
            background: "none",
            border: "none",
            color: "#9ca3af",
            cursor: "pointer",
          }}
        >
          <i className="fas fa-bars" />
        </button>
      </div>

      <Link
        to="/dashboard"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          margin: 12,
          padding: "10px 12px",
          borderRadius: 999,
          background: "#4f46e5",
          color: "#fff",
          textDecoration: "none",
          justifyContent: expanded ? "flex-start" : "center",
        }}
      >
        <i className="fas fa-home" />
        {expanded && <span>Back to Dashboard</span>}
      </Link>

      <nav style={{ padding: "4px 0" }}>
        {MENU.map((item) => {
          if (!canView(item.perms)) return null;

          const active = location.pathname.startsWith(item.route);

          return (
            <NavLink
              key={item.route}
              to={item.route}
              title={!expanded ? item.label : undefined}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: expanded ? "10px 14px" : "10px 0",
                justifyContent: expanded ? "flex-start" : "center",
                color: active ? "#fff" : "#cbd5f5",
                background: active ? "#374151" : "transparent",
                textDecoration: "none",
                fontSize: 14,
              }}
            >
              <i className={item.icon} />
              {expanded && <span>{item.label}</span>}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
